<template>
    <!-- 底部 footer 区域 -->
    <footer class="footer-section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="logo title">
              <img src="@/assets/uupay/images/logo_white.png">
            </div>
            <p class="footer-address">{{ $t('footer.address') }}</p>
            <div class="social-icons">
              <a href="#" class="social-icon"><img src="@/assets/uupay/icon/svg/fb.svg"></a>
              <a href="#" class="social-icon"><img src="@/assets/uupay/icon/svg/x.svg"></a>
              <a href="#" class="social-icon"><img src="@/assets/uupay/icon/svg/ins.svg"></i></a>
            </div>
          </div>
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-4">
                <div class="title">{{ $t('header.ourProduct') }}</div>
                <ul class="footer-list">
                  <li><a href="#">{{ $t('header.appProduct') }}</a></li>
                  <li><a href="#">{{ $t('header.posProduct') }}</a></li>
                  <li><a href="#">{{ $t('header.monitorProduct') }}</a></li>
                </ul>
              </div>
              <div class="col-md-4">
                <div class="title">{{ $t('header.resource') }}</div>
                <ul class="footer-list">
                  <li><a href="#">{{ $t('header.price') }}</a></li>
                  <li><a href="#">{{ $t('footer.news') }}</a></li>
                  <li><a href="#">{{ $t('header.document') }}</a></li>
                </ul>
              </div>
              <div class="col-md-4">
                <div class="title">{{ $t('footer.about') }}</div>
                <ul class="footer-list">
                  <li><a href="#">{{ $t('header.aboutUs') }}</a></li>
                  <li><a href="#">{{ $t('footer.cooperate') }}</a></li>
                  <li><a href="#">{{ $t('header.contactUs') }}</a></li>
                  <li><a href="#">{{ $t('header.news') }}</a></li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>
        <hr style="background-color: #4d4d4d">
        <div class="row footer-copyright flex-column">
          <div class="d-flex justify-content-between footer-private">
            <div class="footer-private-rules">
              <span style="margin-right: 2rem;">{{ $t('footer.privacy') }}</span>
              <span>{{ $t('footer.privacyDetail') }}</span>
            </div>
            <div class="footer-lg">
              <span><img src="@/assets/uupay/icon/svg/lg_white.svg" alt=""></span>
              <span>English</span>
              <span>简体中文</span>
              <span>繁體中文</span>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div>&copy; 2025 UUPay {{ $t('footer.copyright') }}</div>
            <div class="footer-lg">
              <div>
                <span<img src="@/assets/uupay/icon/svg/phone.svg" alt=""></span>
                <span>{{ $t('footer.phone') }}</span>
              </div>
              <div>
                <span<img src="@/assets/uupay/icon/svg/email.svg" alt=""></span>
                <span>{{ $t('footer.email') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>
<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      year: new Date().getFullYear(),
      faqs: [
        {id: 1, title: '為何選擇UUPay？', isShow: false, 
        content: `高性价比：价格透明化，零隐藏成本<br>
                  采用完全透明的定价模式，无 POS 设备租借费、安装费及任何隐性收费项目，最大限度降低商户运营成本。<br>
                  高效管理：实时数据洞察，把握商业趋势<br>
                  通过 UUPay App，商户可随时查看业务数据、分析经营表现，精准捕捉市场趋势与业务机会，助力决策效率提升。<br>
                  操作便捷：一次申请，多元支付解决方案<br>
                  仅需一次申请，即可同步获得多种主流支付方式，无需重复对接，简化商户接入流程。<br>
                  客户体验流畅：支持 19 种主流支付方式<br>
                  覆盖 19 种主流支付渠道（如信用卡、电子钱包等），满足不同客户的支付习惯，提升交易成功率与消费体验。<br>
                  数据安全保障：国际认证的顶级防护体系<br>
                  支付解决方案严格遵循 PCI DSS Level 1（国际支付卡行业数据安全标准）与 ISO 27001（信息安全管理体系）认证，确保交易数据全程加密，守护商户与客户信息安全。<br>
                  全方位服务支持：从安装到售后全程无忧<br>
                  提供专业的 POS 设备安装指导与操作培训，同时通过热线电话与 WhatsApp 提供 7×12 小时专属客户服务，及时响应运营需求。<br>
                  灵活便携：双网络连接，适配多场景经营<br>
                  KPay 智能 POS 支持数据 SIM 卡与 Wi-Fi 双重联网模式，打破固定线路限制，无论是店内固定收银还是移动收款场景，均可轻松应对。`},
        {id: 2, title: '申請所需資料', isShow: false, 
        content: `商戶需要提交有效的身份證明文件、公司註冊證書（有限公司適用）、商業登記證、公司銀行戶口月結單及店舖照片等資料。詳情請向我們的銷售顧問團隊查詢。`},
        {id: 3, title: 'UUPay提供哪些服務？', isShow: false, 
        content: `UUPay針對不同行業提供不同種類的營運系統和工具涵蓋POS系統、客戶管理系統、營銷服務方案等`},
        {id: 4, title: '如何申請UUPay服務？', isShow: false, 
        content: `有意申請收款工具及服務的商戶，可以按此填妥業務資料，我們的業務銷售團隊會儘快跟你聯絡，並安排開通手續。`},
      ],
    }
  }
};
</script>
<style scoped>
	.footer-section {
	  padding: 8rem 0 4rem 0;
	  background-color: #1D2128;
	  color: white;
	}

	.footer-section .footer-address {
	  font-size: 20px;
	  line-height: 30px;
	}

	.footer-section .title {
	  font-size: 20px;
	  font-weight: 500;
	  margin-bottom: 2.5rem;
	}

	.footer-list {
	  list-style: none;
	  padding: 0;
	  margin-top: 4.6rem;
	}

	.footer-list li {
	  margin-bottom: 2.5rem;
	}

	.footer-list li a {
	  color: white;
	  text-decoration: none;
	  font-size: 18px;
	  line-height: 26px;
	  font-weight: 400;
	  color: #c1c1c1;
	}

	.social-icons {
	  display: flex;
	  margin: 6rem 0 2rem 0;
	}

	.social-icon {
	  width: 40px;
	  height: 40px;
	  /*background-color: rgba(255, 255, 255, 0.1);*/
	  /*border-radius: 50%;*/
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  margin-right: 2.5rem;
	  color: white;
	  transition: background-color 0.3s ease;
	}

	.social-icon:hover {
	  /*background-color: #7b2cbf;*/
	}

	.footer-section .footer-copyright {
	  margin-top: 4rem;
	  font-size: 20px;
	  line-height: 26px;
	  color: #e9e9e9;
	  padding: 0 16px;
	}
	.footer-section .footer-private {
	  color: #c1c1c1;
	  margin-bottom: 2.5rem;
	}
	.footer-section .footer-private-rules {
	  
	}
	.footer-section .footer-lg {
	  width: 440px;
	  display: flex;
	  justify-content: space-between;
	}
</style>



// WEBPACK FOOTER //
// src/layout/AppFooter.vue